import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MdOutlineBlock, MdSearch, MdEdit, MdDelete, MdRemoveRedEye, MdMode } from "react-icons/md";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Sort from '../../assets/image/sort-down-alt.svg'
import Filter from '../../assets/image/filter.svg'
import Dummy from '../../assets/image/user-circle.svg'
import Pagination from '../../Components/Pagination/Pagination';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import { Modal } from 'react-bootstrap';

function ViewProgram() {

    const [totalPages, setTotalPages] = useState(0)
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [indexNumber, setIndexNumber] = useState(0)
    const [eventlist, setEventList] = useState([])
    const [delet, setDelet] = useState(false);
    const deleteClose = () => setDelet(false);
    const [program, setProgram] = useState()
    const [school, setSchool] = useState([])
    const location = useLocation()
    const id = location?.state?.id
    const navigate = useNavigate();
    console.log(location)
    const goBack = () => {
        navigate(-1); // Navigates back to the previous page
    };
    const getUserDetails = async () => {
        const response = await handleApiCall("get", `${endpoint.viewProgram}?id=${location?.state?.id}&page=${page}&limit=${perPage}`,);
        try {
            console.log(response, "==================>>>")
            if (response?.data?.code === 200) {
                setProgram(response?.data?.data?.programData)
                setSchool(response?.data?.data?.schoolList)
                setTotalPages(response?.data?.data?.total_pages);
                setTotal(response?.data?.data?.total);
            }
        } catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        getUserDetails(page);
    }, [page]);

   
    const paginationHandler = (e, i) => {
        e.preventDefault();
        console.log("iiii", i);
        if (i != page) {
            setPage(i);
            const newIndexNumber = perPage * (i - 1); // Calculate starting index for the page
            setIndexNumber(newIndexNumber);
            // CcrApiList({
            //     ...searchQuery,
            //     page: i,
            //     limit: perPage
            // })
        }
    };
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-CA"); // Formats as YYYY/MM/DD
    };
    const handleBlock = async () => {

        const response = await handleApiCall("put", `${endpoint.programStatus}`, {
            id: id,
            status: 3
        });
        try {
            console.log(response, "Update STatus...................")
            if (response?.data?.code === 200) {
                toast.success("Program Ended")
                getUserDetails()
            }
            else {
                toast.error(response?.response?.data?.errorMessage || "Technical Issue Please Try Again Later");
                getUserDetails()
            }
        } catch (error) {
            console.log("Error deleting user:", error);
            setDelet(false);

            toast.success(response?.data?.message);
        }
    };

    return (
        <>
            <Toastify />

            <div className="common-table-wrapper m-0 ">
                <div className=" my-3">
                    <div className=' flex  justify-end'>
                        <Link onClick={goBack} className="text-white bg-black hover:text-white outline-1 outline-double rounded-md text-sm font-semibold px-4 py-2 d-inline-block">Back</Link>
                        <button
                            disabled={program?.status === 3}
                            onClick={handleBlock}
                            className={`text-[#994263] py-1 font-bold inline-flex justify-center px-3 ms-2 items-center border-[#994263] rounded-md border-[2px] 
                            ${program?.status === 3 ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:bg-[#e6e0e2]"}`}
                        >
                            End Program
                        </button>
                    </div>
                    <div className='flex-col gap-2 justify-start items-center'>
                        <h2 className=' mr-5 text-[30px]'>{program?.name}</h2>
                        <p className=' gap-3 flex font-normal my-2'><span>{formatDate(program?.start_date)}</span>  - <span>{formatDate(program?.end_date)}</span></p>
                    </div>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-8 sm:grid-cols-3 gap-3 my-2 mb-2 ">

                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E]">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Region</span>
                        <span className="font-bold text-lg text-wrap ">{program?.region_name}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E]">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Country</span>
                        <span className="font-bold text-lg text-wrap ">{program?.country_name}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E]">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">State</span>
                        <span className="font-bold text-lg text-wrap ">{program?.state_name}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E]">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Total Districts</span>
                        <span className="font-bold text-lg text-wrap ">{program?.total_no_of_district}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E]">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Total Schools</span>
                        <span className="font-bold text-lg text-wrap ">{program?.total_no_of_school}</span>
                    </div>
                </div>

                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr className=' mx-3'>
                                <th>Sr.No.</th>
                                <th>School ID</th>
                                <th>School Name</th>
                                <th>District</th>
                                <th>Block</th>
                                <th>Coach name</th>
                                <th className=''>Action</th>

                            </tr>
                        </thead>
                        <tbody>
                            {school?.length > 0 ? school.map(({ _id, block_id, block_name, coach_id, coach_name, district_id, district_name, school_name, school_unique_id }, i) =>
                                <tr>
                                    <td>{indexNumber + i + 1}</td>
                                    <td>{school_unique_id}</td>
                                    <td>{school_name}</td>
                                    <td> {district_name}</td>
                                    <td>{block_name}</td>
                                    <td>{coach_name}</td>

                                    <td className="action-tab flex justify-end gap-2 ">
                                        <button onClick={() => navigate("/school-management/view-user", { state: { id: _id } })} className="action-icon view-info bg-slate-300 rounded-full p-1"><MdRemoveRedEye style={{ width: '17px', height: '17px' }} /></button>
                                    </td>
                                </tr>) :
                                <tr className="justify-center">
                                    <td colSpan="100%">
                                        <h6 className=" text-center from-neutral-950 text-lg">No School Found.</h6>
                                    </td>
                                </tr>
                            }


                        </tbody>
                    </table>
                </div>
                <Row className="mt-4 px-2">
                    <Col md={12}>
                        <Pagination
                            data={school}
                            indexNumber={indexNumber}
                            totalPage={totalPages}
                            setPage={setPage}
                            page={page}
                            paginationHandler={paginationHandler}
                            total={total}
                        />
                    </Col>
                </Row>
            </div>
            {/* <Modal dialogClassName="modal-custom-sm" centered show={delet} onHide={deleteClose}>
        <Modal.Body className='p-0'>
            <div className="card logout-card common_box">
                <div className="card-body common_box_body py-4 px-3">
                    <p className="modalTitle text-center mb-2 fw-bold">Are you sure you want to<br />delete this User?</p>
                    <form className="custom_form">
                        <div className="btn-wrapper text-center">
                            <button className="btn btn-form btn-cancel" onClick={deleteClose}>No</button>
                            <button className="btn btn-form btn-add" onClick={(e) => handleDelete(e)}>Yes</button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal.Body>
    </Modal> */}
        </>
    )
}

export default ViewProgram